import React from "react";
import AppRouter from "./routes/AppRouter";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Layout from "./layouts/Layout";
import theme from "./theme";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Layout>
        <AppRouter />
      </Layout>
    </ThemeProvider>
  );
}

export default App;
